var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfirmationError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12873",
    "data-name": "Rectangle 12873",
    width: 36,
    height: 36,
    transform: "translate(502 270)",
    fill: "#e60050",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1381",
    "data-name": "Mask Group 1381",
    transform: "translate(-502 -270)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "danger",
    transform: "translate(501.999 271.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21380",
    "data-name": "Path 21380",
    d: "M18.35,3.612a7.7,7.7,0,0,1,8.241,3.811L36.949,26.067A7.24,7.24,0,0,1,30.62,36.823H9.1A7.24,7.24,0,0,1,2.772,26.067L13.129,7.423A7.7,7.7,0,0,1,18.35,3.612Zm2.528,2.463a5.188,5.188,0,0,0-5.553,2.568L4.967,27.287A4.729,4.729,0,0,0,9.1,34.311H30.62a4.728,4.728,0,0,0,4.133-7.025L24.4,8.643a5.188,5.188,0,0,0-3.518-2.568Z",
    transform: "translate(-1.86 -3.462)",
    fill: "#e60050",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21381",
    "data-name": "Path 21381",
    d: "M18,21.488a1.256,1.256,0,0,1-1.256-1.256v-6.7a1.256,1.256,0,0,1,2.512,0v6.7A1.256,1.256,0,0,1,18,21.488Z",
    transform: "translate(0 -2.36)",
    fill: "#e60050",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21382",
    "data-name": "Path 21382",
    d: "M18,26.047a1.256,1.256,0,0,0,1.256-1.256v-.837a1.256,1.256,0,0,0-2.512,0v.837A1.256,1.256,0,0,0,18,26.047Z",
    transform: "translate(0 -1.058)",
    fill: "#e60050",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationError);
export default __webpack_public_path__ + "static/media/confirmationError.e7f39056243cd8137b2b65469b014079.svg";
export { ForwardRef as ReactComponent };